import { useCallback } from "react";
/**
 * Returns an onInput handler that auto-resizes a textarea to fit its content,
 * capped at maxHeightPx. Replaces direct DOM style mutations in JSX event handlers.
 */
export function useAutoResize(maxHeightPx = 160) {
    return useCallback((e) => {
        const el = e.currentTarget;
        el.style.height = "auto";
        el.style.height = `${Math.min(el.scrollHeight, maxHeightPx)}px`;
    }, [maxHeightPx]);
}
